import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'utils/axios';
import { onAuthStateChanged } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';
import { auth } from '../../firebase';

const initialState = {
  fetching: false,
  fetchingSuccessful: false,
  fetchingFailed: false,
  error: false,
  errorText: '',
  tokenData: null,
};

export const fetchTranscriptionSessionToken = createAsyncThunk(
  'transcription/fetchTranscriptionSessionToken',
  async (_, { dispatch, rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        try {
          const token = await user?.getIdToken();
          const reqId = uuidv4();

          const response = await axios.post(
            `/cs/transcription-sessions`,
            null,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            resolve(response.data);
          } else {
            reject(
              rejectWithValue('Failed to get transcription session token'),
            );
          }
        } catch (e) {
          reject(rejectWithValue('Failed to get transcription session token'));
        } finally {
          unsubscribe();
        }
      });
    });
  },
);

const transcriptionSlice = createSlice({
  name: 'transcription',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTranscriptionSessionToken.pending, (state) => {
        state.fetching = true;
      })
      .addCase(fetchTranscriptionSessionToken.fulfilled, (state, action) => {
        state.fetching = false;
        state.fetchingSuccessful = true;
        state.fetchingFailed = false;
        state.error = false;
        state.errorText = '';
        state.tokenData = action.payload;
      })
      .addCase(fetchTranscriptionSessionToken.rejected, (state, action) => {
        state.fetching = false;
        state.fetchingFailed = true;
        state.error = true;
        state.errorText =
          action.payload || 'Failed to get transcription session token';
        state.tokenData = null;
      });
  },
});

export default transcriptionSlice.reducer;
